import {FC} from 'react';
//mui
import {Box, Typography} from '@mui/material';
//icons
import {ReactComponent as EllipseBlueIcon} from '@icons/ellipse-blue.svg';
//types
import {INotification} from '@/utils/types';
//constants
import {SUBTITLE2} from '@constants/index';
//styles
import {notificationItemStyle} from './NotificationItem.styles';
//helpers
import {calculateNotificationTime} from '@/utils/helpers';

interface INotificationItemProps {
	notificationItem: INotification;
	handleClick: (prop: INotification) => void;
}

const NotificationItem: FC<INotificationItemProps> = ({notificationItem, handleClick}) => {
	return (
		<Box sx={notificationItemStyle.wrapper} onClick={() => handleClick(notificationItem)}>
			{!notificationItem.isRead && (
				<Box sx={notificationItemStyle.icon}>
					<EllipseBlueIcon />
				</Box>
			)}

			<Box sx={notificationItemStyle.content}>
				<Typography sx={notificationItemStyle.title} variant={SUBTITLE2}>
					{notificationItem.title}
				</Typography>

				<Typography sx={notificationItemStyle.description} variant={SUBTITLE2}>
					{notificationItem.description}
				</Typography>
			</Box>
			<Box>
				<Typography sx={notificationItemStyle.date}>{calculateNotificationTime(notificationItem.dateSend)}</Typography>
			</Box>
		</Box>
	);
};

export default NotificationItem;
